document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  const closeButton = popup.querySelector('.close-button');
  const form = document.getElementById('newsletter-form');
  const formUI = popup.querySelector('.newsletter-form-ui');
  const overlay = popup.querySelector('.popup-overlay');
  
  const POPUP_STORAGE_KEY = 'newsletter_popup_closed';
  
  // Get settings from section
  const section = popup.closest('[data-section-type="custom-dialog"]') || popup.closest('.shopify-section');
  const popupEnabled = popup.dataset.popupEnabled === 'true';
  const popupDelay = parseInt(popup.dataset.popupDelay || '1') * 1000;
  const discountCode = popup.dataset.discountCode || 'WELCOME5';
  const forceShow = popup.dataset.forceShow === 'true';
  
  // In FB testing mode, phantom button is shown instead
  if (forceShow) {
    console.log('FB Testing Mode: Phantom button is active for Facebook Pixel setup');
    return; // Don't initialize popup in testing mode
  }
  
  function isPopupClosed() {
    return localStorage.getItem(POPUP_STORAGE_KEY) === 'true';
  }
  
  function markPopupAsClosed() {
    localStorage.setItem(POPUP_STORAGE_KEY, 'true');
  }
  
  function showSuccessScreen() {
    const successScreen = document.getElementById('success-screen');
    const formUI = popup.querySelector('.newsletter-form-ui');
    const popupTitle = popup.querySelector('.popup-title');
    const descriptionText = popup.querySelector('.description-text');
    const discountCodeInput = document.getElementById('discount-code');
    
    discountCodeInput.value = discountCode;
    
    formUI.style.display = 'none';
    popupTitle.style.display = 'none';
    descriptionText.style.display = 'none';
    
    successScreen.style.display = 'flex';
  }
  
  function hideSuccessScreen() {
    markPopupAsClosed();
    popup.classList.remove('show');
    document.body.classList.remove('popup-open');
  }

  function showPopup() {
    if (isPopupClosed() && !forceShow) {
      return;
    }
    popup.classList.add('show');
    document.body.classList.add('popup-open');
  }

  function hidePopup() {
    if (forceShow) {
      return;
    }
    popup.classList.remove('show');
    document.body.classList.remove('popup-open');
    markPopupAsClosed();
  }

  overlay.addEventListener('click', hidePopup);
  
  const popupContainer = popup.querySelector('.popup-container');
  popupContainer.addEventListener('click', function(e) {
    if (e.target === popupContainer) {
      hidePopup();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('show')) {
      hidePopup();
    }
  });

  const submitButton = formUI.querySelector('.submit-button');
  submitButton.addEventListener('click', function(e) {
    e.preventDefault();
    
    const email = document.getElementById('email').value;
    const descriptionText = popup.querySelector('.description-text');
    const hiddenEmailInput = form.querySelector('.email-input-hidden');
    
    if (!email) return;
    
    submitButton.disabled = true;
    const originalText = submitButton.querySelector('.button-text').textContent;
    submitButton.querySelector('.button-text').textContent = 'Loading...';
    
    hiddenEmailInput.value = email;
    
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.name = 'newsletter-submit-frame';
    document.body.appendChild(iframe);
    
    form.target = 'newsletter-submit-frame';
    
    let hasLoaded = false;
    
    iframe.onload = function() {
      if (!hasLoaded) {
        hasLoaded = true;
        setTimeout(() => {
          showSuccessScreen();
          document.body.removeChild(iframe);
        }, 500);
      }
    };
    
    setTimeout(() => {
      if (!hasLoaded) {
        console.error('Newsletter subscription timeout');
        descriptionText.textContent = 'Something went wrong. Please try again.';
        descriptionText.style.color = '#dc3545';
        
        submitButton.disabled = false;
        submitButton.querySelector('.button-text').textContent = originalText;
        
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }
    }, 10000);
    
    form.submit();
  });

  const emailInput = document.getElementById('email');
  emailInput.addEventListener('keypress', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      submitButton.click();
    }
  });

  const copyButton = popup.querySelector('.copy-button');
  const continueShoppingButton = popup.querySelector('.continue-shopping-button');
  
  copyButton.addEventListener('click', function() {
    const discountCodeInput = document.getElementById('discount-code');
    discountCodeInput.select();
    discountCodeInput.setSelectionRange(0, 99999);
    
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  });
  
  continueShoppingButton.addEventListener('click', hideSuccessScreen);
  
  closeButton.addEventListener('click', function() {
    const successScreen = document.getElementById('success-screen');
    if (successScreen.style.display === 'flex') {
      hideSuccessScreen();
    } else {
      hidePopup();
    }
  });
  
  if (popupEnabled || forceShow) {
    setTimeout(showPopup, forceShow ? 0 : popupDelay);
  }
});

